/* eslint-disable @typescript-eslint/no-explicit-any */

import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { DataTableValue } from 'primereact/datatable';

import { Table } from '@/components';
import { Value } from '@/types/getPendingPaymentsType';

import { getTableColumns } from './columns';
import { filters as tableFilters } from './filters';
import { PendingPaymentsFiltersType } from '../PendingPaymentsFilters';
import style from './PendingPaymentsTable.module.scss';

type PendingPaymentsTableProps = {
  data?: Value[];
  isLoading?: boolean;
  handleSelectionChange?: (e: { value: unknown }) => void;
  selectedItems?: Value[] | undefined;
  filters: PendingPaymentsFiltersType;
  getData: any;
};

const PendingPaymentsTable: FC<PendingPaymentsTableProps> = ({
  data,
  isLoading,
  handleSelectionChange,
  selectedItems,
  filters,
  getData,
}) => {
  const { t } = useTranslation('pendingPayments');

  const total = useMemo(() => {
    const totalAmount = data?.reduce((acc, item) => {
      if (item?.estado === 'En Edición') {
        return acc + (item?.totalAmount ?? 0);
      }
      return acc;
    }, 0);

    const totalFormatted = totalAmount?.toLocaleString('es-UY', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    return totalFormatted;
  }, [data]);

  const columns = useMemo(
    () => getTableColumns(data, t, filters, getData),
    [data, t, filters, getData]
  );

  return (
    <div className={style.tableContainer}>
      <Table
        footer={
          <div className="w-full flex flex-column align-items-end">
            <p className="font-normal">{t('amountToPay')}</p>
            <h2>U$S {total}</h2>
          </div>
        }
        columns={columns}
        data={data as DataTableValue[]}
        isLoading={isLoading}
        onSelectionChange={handleSelectionChange}
        filterDisplay="menu"
        selectedItems={selectedItems as DataTableValue[]}
        selectionId="oid"
        filters={tableFilters}
      />
    </div>
  );
};

export default PendingPaymentsTable;
